import React from 'react';
import ReactDOM from 'react-dom';
import FormModuleLookup from '../components/FormModuleLookup';
import FormItemTimeEditor from './FormItemTimeEditor';
import EditorForDataGridMix from './EditorForDataGridMix';
import LookupActions from '../actions/LookupActions';
import RecordsActions from '../actions/RecordsActions';
import {RecordFieldChangeStore} from '../stores/RecordsStore';
import {DsAllowEditStore} from '../stores/CmdTypeStore';
import FormItemTimeResolver from './resolver/FormItemTimeResolver';
import FormItemConst from './FormItemConst';

export default class FormItemTimeEditorForDataGrid extends EditorForDataGridMix(FormItemTimeEditor)
{

	initStores()
	{
		this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
		this.unsubscribeDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
	}

	componentWillUnmount()
	{
		this.unsubscribeRecordFieldChangeStore();
		this.unsubscribeDsAllowEditStore();
		this.closeDropDown();
	}

	onDsAllowEditStore(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			let finalValue = this.props.control.getProperty_AllowEdit_Final();

			this.doSetEnable(finalValue);	
		}
		
	}

	getValue(){
	    let updated = {};
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		this.justCommit = true;
	    let text = this.getInputNode().value;
	    var _val = FormItemTimeResolver.getResult(text,false);
		if(_val.indexOf("false:") == 0)
		{
			alert(_val.substr(6));
			_val = this.props.value;
		}


	    updated[this.props.column.key] = _val;

	    if(this.props.value != updated[this.props.column.key])
	    {
	    	RecordsActions.RecordFieldChanged(this.props.rowData,this.props.column.key,this.props.value,updated[this.props.column.key],this);
	    	if(this.props.control)
	    	{
				let result;
				if(this.props.column.isdynamic == true)
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName,_val,this.props.value,null,null,{dynamicColumn:true,dynamicKey:this.props.column.dynamicFieldLabel});
				}
				else
				{
					let _oldValue = this.props.value;
					result = this.props.control.doFieldModifiedRemote(this.props.column.key,_val,_oldValue);
				}
	    		
	    		if(!result)
	    		{
	    			return {};
	    		}
	    	}
	    }
	    return updated;
	}

	componentDidMount()
	{
		if(this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
			this.doSetEnable(_allowEdit);
		}

		if(this.props.contextMenuData)
			$(this.inputField).contextPopup(this.props.contextMenuData);
		
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			$(this.inputField).css("backgroundColor",FormItemConst.EDITOR_NOTEDIT_COLOR);
			$(this.inputField).attr("readonly","readonly");
			$(this.downArrowButton).css("display","none");
		}
		else if(nowAllowEdit == false && enable == true)
		{
			$(this.inputField).css("backgroundColor","#FFFFFF");
			$(this.inputField).removeAttr("readonly");
			$(this.downArrowButton).css("display","block");
		}
	}

	getDownArrowButtonDom()
	{
		if(this.state.allowEdit)
		{
			return <i ref={node => this.downArrowButton = node} onClick={this.showDropDown.bind(this)} className="fa fa-clock-o" style={{position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
		}
		else
		{
			return <i ref={node => this.downArrowButton = node} className="fa fa-clock-o" style={{position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
		}
	}

	handleBlurCommit()
	{
		if(this.justCommit == true)
		{
			this.justCommit = false;return false;
		}
	   if(this.dropDownShowed)
	   	return false;
	   return true;
	}

	onKeyDownHandler(e)
	{
		//禁用ctrl+A
		if(e.ctrlKey && e.keyCode == 65)
		{
		  e.stopPropagation();
		  return true;
		}
		super.onKeyDownHandler(e);
	}

	showDropDown()
	{
		if(this.dropDownShowed == true)
		{
			this.closeDropDown();
			return;
		}
		let $dropdown = this.getDropDownHtml();
		$('body').append($dropdown);
		this.dropdownform = $dropdown;
		var lookupdiv = $dropdown;


		if(this.inputField.defaultValue && typeof(this.inputField.defaultValue) == "string")
		{
			let nowVal = this.inputField.defaultValue ;
			let hourLis = $(".dateTimeWrap #selHour>ol>li");
			let minuteList = $(".dateTimeWrap #selMinute>ol>li");
			let secondsList = $(".dateTimeWrap #selSecond>ol>li");
			let _arr = nowVal.split(":");
			let nowHour = _arr[0];let nowMinute = _arr[1];let nowSecond = _arr[2];
			for(let i = 0;i<hourLis.length;i++)
			{
				let item = hourLis[i];
				if($(item).html() == nowHour)
				{
					hourLis.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}

			for(let k = 0;k<minuteList.length;k++)
			{
				let item = minuteList[k];
				if($(item).html() == nowMinute)
				{
					minuteList.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}
			for(let k = 0;k<secondsList.length;k++)
			{
				let item = secondsList[k];
				if($(item).html() == nowSecond)
				{
					secondsList.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}
		}










		var _inputwidth = $(this.inputField).width();//this.props.displayLengthWidth;
		var _iframewidth = lookupdiv.outerWidth();
		
		var _iframeheight = lookupdiv.outerHeight();
		
		var _gwidth = $("#app").width();
		var _gheight = $("#app").height();

		if(_iframewidth>_gwidth)
		{
			_iframewidth = _gwidth;
			lookupdiv.css({width:_iframewidth+'px',overflow:"auto"});
		}
		var _offset = $(this.inputField).offset();
		var _y = _offset.top; 
		var _x = _offset.left;
		var _top = _y+$(this.inputField).height()+8;
		//alert('x:'+_x+'y:'+_y);
		//下方屏幕放不下
		if((_top+_iframeheight)>_gheight)
		{
			//上下都放不下 考虑缩减高度
			if(_iframeheight>_y)
			{
				//上方空间大
				if(_y>(_gheight/2))
				{
					lookupdiv.height(_y-2);
					_top = '0px';
				}
				else //下方空间大
				{
					lookupdiv.css("height",(_gheight-_top)+'px');	
				}
			}
			else//下拉框置于上方
			{
				_top = (_y-_iframeheight)+'px';
			}
		}
		var _left = _x-((_iframewidth-_inputwidth)/2);
			//(_iframewidth-_inputwidth)/2;
		if(_left+_iframewidth>_gwidth)
			_left = _gwidth-_iframewidth-5;
		if(_left<0)_left = 0;
		
		lookupdiv.css({left:(_left+'px'),top:_top});
		this.dropDownShowed = true;
		this.attachEventListeners();
	}
	
	render()
	{
		let rowStyles = this.getRowStyles();
		let _style = {padding:'2px 13px 2px 2px',width:'100%',backgroundColor:'#ffffff',fontSize:"12px",cursor:'text'};
		let _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}
		if(this.props.height){
			_style.maxHeight=this.props.height-2;
		}
		let dropdown = this.getDownArrowButtonDom();

		let _v = this.props.value;
		/*if(this.props.hasInitialValue == true && this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final();

			if(_allowEdit == false)
			{
				if(this.props.column && this.props.column.key)
				{
					let _value = this.props.rowData[this.props.column.key];
					_v = _value;
				}
			}
		}*/
		return(
			<div ref={node=>this.inputFieldContainer = node}>
		        <input spellCheck="false" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="text" 
		        	   className="form-control" style={_style} defaultValue={_v}/>
				{dropdown}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/FormItemTimeEditorForDataGrid.js